var _defs, _text, _text2, _tspan, _tspan2, _tspan3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTitleFr = function SvgTitleFr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "title_fr_svg__Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 955 75",
    "aria-labelledby": "Pr\\xE9commandez en mode facile"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".title_fr_svg__cls-5{font-family:inherit;font-size:inherit;fill:#ffd14f}"))), /*#__PURE__*/React.createElement("g", {
    id: "title_fr_svg__Accueil"
  }, /*#__PURE__*/React.createElement("g", {
    id: "title_fr_svg__PRESENTATION"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "title_fr_svg__cls-5",
    transform: "translate(0 59.06)",
    id: "title_fr_svg__Pr\\xE9commander_en_mode_facile",
    "data-name": "Pr\\xE9commander en mode facile"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PR\xC9COMMANDEZ EN MODE FACILE"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "title_fr_svg__cls-5",
    transform: "translate(5 54.06)",
    id: "title_fr_svg__Pr\\xE9commander_en_mode_facile-2",
    "data-name": "Pr\\xE9commander en mode facile"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PR\xC9COMMANDEZ EN MODE FACILE"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 54.06)",
    style: {
      fill: "#bee5cf",
      fontFamily: "inherit",
      fontSize: "inherit"
    },
    id: "title_fr_svg__Pr\\xE9commander_en_mode_facile-3",
    "data-name": "Pr\\xE9commander en mode facile"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PR\xC9COMMANDEZ EN MODE FACILE"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(5 59.06)",
    style: {
      fill: "#ef9f99",
      fontFamily: "inherit",
      fontSize: "inherit"
    },
    id: "title_fr_svg__Pr\\xE9commander_en_mode_facile-4",
    "data-name": "Pr\\xE9commander en mode facile"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PR\xC9COMMANDEZ EN MODE FACILE"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(3 57.06)",
    style: {
      fontFamily: "inherit",
      fontSize: "inherit",
      fill: "#4c4c4c"
    },
    id: "title_fr_svg__Pr\\xE9commander_en_mode_facile-5",
    "data-name": "Pr\\xE9commander en mode facile"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PR\xC9COMMANDEZ EN MODE FACILE"))))));
};
export default SvgTitleFr;